// apps/dashboard/src/lib/onboarding-exempt-paths.ts

// Pages an authenticated but not-yet-onboarded user may open without being sent to
// /onboarding. Prefix matches, kept as they were when this list lived in OnboardingGuard.
const SKIP_PREFIXES = [
  '/onboarding',
  '/verify-email',
  '/login',
  '/register',
  '/forgot-password',
  '/coming-soon',
  '/maintenance',
  '/claim',
  '/join',
  // Money already in flight. Reaching an order means the user has committed to
  // a purchase and needs the VA number / status to finish paying, and gating that
  // behind a profile questionnaire strands them mid-checkout, which is the one
  // moment the funnel can least afford an interstitial.
  '/payments',
];

// Email-link landing pages served by this app on white-label and demo instances. They
// consume a single-use token, so they must run whatever the onboarding state: gating them
// held verification hostage until the user clicked through every onboarding screen. Exact
// or "/segment/..." only (same rule as middleware's public paths), so /auth/action-x is not
// exempt.
const SKIP_EXACT_PATHS = ['/auth/verify', '/auth/action'];

export function isOnboardingExempt(pathname: string): boolean {
  return (
    SKIP_PREFIXES.some((p) => pathname.startsWith(p)) ||
    SKIP_EXACT_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`))
  );
}
